import { useLayout as useHostLayout } from "../../../contexts/LayoutContext";

export const useLayout = () => {
  return useHostLayout();
};
